import { Link } from "react-router-dom"; // Dùng React Router

const LetsTalkSection = () => {
  return (
    <section className="lets-talk-section fix section-padding section-bg pb-0">
      <div className="container">
        <div className="lets-talk-wrapper">
          <h2
            className="wow fadeInUp"
            data-wow-delay=".3s"
          >
            Đang có ý tưởng cho dự án? <br /> Hãy cùng nhau hiện thực hóa!
          </h2>
          <Link
            to="/lien-he"
            className="theme-btn wow fadeInUp"
            data-wow-delay=".5s"
          >
            Liên hệ ngay!
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LetsTalkSection;
